var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "h-100 d-flex flex-column",
      attrs: { elevation: "0", outlined: "", "min-height": "350" },
    },
    [
      _c(
        "v-card-title",
        {
          staticClass:
            "py-1 white--text d-flex align-center justify-space-between",
          class: _vm.$vuetify.theme.dark ? "black" : "primary",
          staticStyle: { "flex-wrap": "nowrap" },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-center",
              staticStyle: { flex: "1 1 auto", "min-width": "0" },
            },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "white", medium: "" } },
                [_vm._v("people")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis",
                },
                [_vm._v(_vm._s(_vm.$t("dashboards.myCollections")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "pl-0 pr-0",
              staticStyle: { "flex-shrink": "0" },
              attrs: { text: "", small: "", to: `/collections` },
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "white--text text-decoration-underline font-weight-bold",
                },
                [_vm._v(_vm._s(_vm.$t("general.seeAll")))]
              ),
              _vm._v(" "),
              _c(
                "v-icon",
                { staticClass: "ml-1", attrs: { small: "", color: "white" } },
                [_vm._v("keyboard_arrow_right")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        {
          staticClass: "d-flex flex-column flex-grow-1 pa-0",
          staticStyle: { "min-height": "0" },
        },
        [
          !_vm.loading
            ? [
                _vm.collections && _vm.collections.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column pl-3 pr-3 pb-1 pt-2 flex-grow-1",
                        staticStyle: { overflow: "auto" },
                      },
                      _vm._l(_vm.collections, function (collection, index) {
                        return _c("CollectionCard", {
                          key: index,
                          attrs: { collection: collection, embedded: "" },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.collections || !_vm.collections.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column px-3 py-4 mb-7 text-center flex-grow-1 justify-center align-center",
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            style: {
                              "font-size": _vm.$vuetify.breakpoint.mdAndUp
                                ? "80px"
                                : "60px",
                            },
                            attrs: { color: "primary lighten-5" },
                          },
                          [_vm._v("create_new_folder")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "primary--text lighten--text-2 body-1",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("dashboards.placeholderCollections")
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-4 pl-6 pr-4 d-flex align-center justify-space-between",
                  },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "30%" },
                    }),
                    _vm._v(" "),
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "15%" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "px-6 py-4 flex-grow-1 d-flex flex-column justify-space-around",
                  },
                  _vm._l(4, function (i) {
                    return _c("v-skeleton-loader", {
                      key: i,
                      staticClass: "my-2",
                      attrs: { type: "text", width: "100%" },
                    })
                  }),
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }